var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcurementNumberAnnounced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_605_6541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 16.2187L8.8125 13.4062L14.0625 16.2187L13.0312 10.3125L17.3438 6.1875L11.4375 5.34375L8.8125 0L6.1875 5.34375L0.28125 6.1875L4.59375 10.3125L3.5625 16.2187ZM3.375 7.21875L7.125 6.65625L8.8125 3.1875L10.5 6.65625L14.25 7.21875L11.5313 9.84375L12.1875 13.5937L8.8125 11.8125L5.4375 13.5937L6.09375 9.84375L3.375 7.21875Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7188 5.71875H21.4688V7.125H59.7188V5.71875Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6563 10.2188H21.4688V11.625H48.6563V10.2188Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 38.0625L8.8125 35.25L14.0625 38.0625L13.0312 32.1562L17.3438 28.0312L11.4375 27.1875L8.8125 21.8438L6.1875 27.1875L0.28125 28.125L4.59375 32.25L3.5625 38.0625ZM3.375 29.0625L7.125 28.5L8.8125 25.0313L10.5 28.5L14.25 29.0625L11.5313 31.6875L12.1875 35.4375L8.8125 33.6563L5.4375 35.4375L6.09375 31.6875L3.375 29.0625Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7188 27.6562H21.4688V29.0625H59.7188V27.6562Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6563 32.1562H21.4688V33.5625H48.6563V32.1562Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3438 49.9687L11.4375 49.125L8.8125 43.7812L6.1875 49.125L0.28125 49.9687L4.59375 54.0937L3.5625 60L8.8125 57.1875L14.0625 60L13.0312 54.0937L17.3438 49.9687ZM8.8125 55.5937L5.4375 57.375L6.09375 53.625L3.375 51L7.125 50.4375L8.8125 46.9687L10.5 50.4375L14.25 51L11.5313 53.625L12.1875 57.375L8.8125 55.5937Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7188 49.5H21.4688V50.9062H59.7188V49.5Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6563 54.0938H21.4688V55.5H48.6563V54.0938Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_605_6541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcurementNumberAnnounced);
export default __webpack_public_path__ + "static/media/procurementNumberAnnounced.a306c58c90610f7e99c917ac9f61608b.svg";
export { ForwardRef as ReactComponent };